// Discriminator values for `User.userType`. Mirrors TeamflectApp backend
// `constants/userConstants.js` + `models/user.js` schema enum (default `'microsoft365'`).
// Always check EXTERNAL — legacy rows lack the field and fall through to MICROSOFT_365.

const USER_TYPE = {
  MICROSOFT_365: 'microsoft365',
  EXTERNAL: 'external'
}

// Analytics vocabulary for `User.userType`, kept SEPARATE from USER_TYPE on purpose: the
// product/data contract names the external tier `non_microsoft`, while the stored value is
// `external`. Mirrors takdirclient's `constants/userConstants.ts` so the App and Admin report
// one spelling into the same Mixpanel/Intercom properties.
const ANALYTICS_USER_TYPE = {
  [USER_TYPE.MICROSOFT_365]: USER_TYPE.MICROSOFT_365,
  [USER_TYPE.EXTERNAL]: 'non_microsoft'
}

/**
 * Translate a stored `User.userType` into the analytics vocabulary.
 *
 * Anything that is not an own key of the map falls back to microsoft365: legacy rows predate
 * the field and the schema getter that defaults it does NOT run on `.lean()` reads. Own-key
 * test rather than a nullish check, so `''` and inherited keys such as `constructor` cannot
 * leak a bare `undefined` or a function into the payload.
 *
 * @param   {string} [userType] - Stored discriminator; absent on legacy rows.
 * @returns {string} `non_microsoft` for external, else `microsoft365`.
 * @example analyticsUserType(userData.userType) // 'non_microsoft'
 */
const analyticsUserType = userType =>
  Object.prototype.hasOwnProperty.call(ANALYTICS_USER_TYPE, userType)
    ? ANALYTICS_USER_TYPE[userType]
    : ANALYTICS_USER_TYPE[USER_TYPE.MICROSOFT_365]

export { USER_TYPE, ANALYTICS_USER_TYPE, analyticsUserType }
